import { modals } from 'presentation/main/modals/modals'
import { InviteMembersModal } from 'presentation/screens/MembersScreen/components/InviteMembersModal/InviteMembersModal'
import { MemberReactivateModal } from 'presentation/screens/MembersScreen/components/MemberActivationModal/MemberReactivateModal'
import { UserInfoModal } from 'presentation/screens/MembersScreen/components/UserInfoModal'

modals.register('INVITE_MEMBERS_MODAL', InviteMembersModal)
modals.register('USER_INFO_MODAL', UserInfoModal)
modals.register('MEMBER_REACTIVATE_MODAL', MemberReactivateModal)
